export default [
  {
    path: '/message/list',
    name: 'messageList',
    component: () => import('@/view/message/list.vue'),
    meta: { pageName: 'page_message_list' }
  },
  {
    path: '/message/detail-promise',
    name: 'messageDetail',
    component: () => import('@/view/message/detail-promise.vue'),
    meta: { pageName: 'page_message_detail_promise' }
  },
  {
    path: '/message/detail-letter',
    name: 'messageDetail2',
    component: () => import('@/view/message/detail-letter.vue'),
    meta: { pageName: 'page_message_detail_letter' }
  },
  {
    path: '/message/detail-refund-auth',
    name: 'messageDetail3',
    component: () => import('@/view/message/detail-refund-auth.vue'),
    meta: { pageName: 'page_message_detail_refund' }
  },
  {
    path: '/message/detail-file-sign',
    name: 'messageDetail4',
    component: () => import('@/view/message/detail-file-sign.vue'),
    meta: { pageName: 'page_message_detail_file_sign' }
  },
  {
    path: '/message/refund-auth',
    name: 'refundAuth',
    component: () => import('@/view/message/refund/index.vue'),
    meta: { pageName: 'page_message_detail_refund_index' }
  },
  {
    path: '/message/refund-protocol',
    name: 'refundAuthProtocol',
    component: () => import('@/view/message/refund/protocol-promise.vue'),
    meta: { pageName: 'page_message_detail_refund_protocol' }
  }
]